// Generated by ReScript, PLEASE EDIT WITH CARE

import WrappedPieBindJs from "./WrappedPie.bind.js";

var make = WrappedPieBindJs;

export {
  make ,
  
}
/* make Not a pure module */
